import React from 'react';
import { products } from './movice';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import '..//mystyle.css'
import { Link } from 'react-router-dom';

const Details = ({ addToCart, cart }) => {

useEffect(() => {
  window.scrollTo(0, 0);
}, []);

const { id } = useParams();

const film = products.find((item) => item.id == id);

if (!film) {
  return <h2>Film Not Found</h2>;
}

const exist = cart.find((item) => item.id === film.id);

return (

<section style={{marginTop:'15%'}}>

<section className="section">
<div className="container">

<div className="row row-details">

<div className="col-lg-6">
  <img
    src={film.img}
    alt=""
    style={{width:'300px',height:'440px'}}
    className="img-fluid"
  />
</div>

<div className="col-lg-6">

  <h3 className="font-tertiary mb-3">
    Film {film.name}
  </h3>

  <strong>{film.dis}</strong>

  <iframe
    width="100%"
    height="300"
    src={film.vid}
    title="Trailer"
  ></iframe>

  <div className='button mt-3'>

    <Link state={film} to='/buy'><button className='btn btn-primary buy'>BUY {film.buy}</button> </Link>


    {exist ? (

        <button data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" className="btn btn-success">
          View Basket
        </button>

    ) : (

      <button
        className='btn btn-primary'
        onClick={() => addToCart(film)}
      >
        Add to basket <i className="bi bi-cart-fill"></i>
      </button>

    )}

  </div>

</div>

</div>

</div>
</section>

</section>

);
}

export default Details;